<footer class="text-center" *ngIf="router != '/login'">
	<span>&copy; Copyright 2017 G-Cube. All rights reserved  | <a href="javascript:void(0);">TERMS OF USE</a> | <a href="javascript:void(0);">Privacy Policy</a></span>
</footer>